import {formatGrams} from '@utils/utils'
import React, {useReducer} from 'react'
import {getColliTypeName} from '../../../utils/getColliTypeName.js'
import {Colors, IconButton, P, S1, S2} from 'src/components/UI'
import {Order, Collo, Reseller} from 'types/types.js'

type ViewOrderColloProps = {
    order: Order
    collo: Collo
    reseller: Reseller
    noBorder: boolean
    onClickEdit?: (index: number) => void
    onClickPrintLabels?: (orderId: string, index: number) => void
}

type ViewOrderColloState = {
    hover: boolean
}

const ViewOrderCollo = ({order, collo, reseller, noBorder, onClickEdit, onClickPrintLabels}: ViewOrderColloProps) => {
    const [state, setState] = useReducer((s: ViewOrderColloState, a: ViewOrderColloState) => a, {hover: false})

    const {hover} = state

    const disabled = ['cancelled'].includes(collo.status)

    return (
        <div style={{display: 'flex', flex: 1, minHeight: 36, borderBottom: !noBorder && `1px solid ${Colors.border}`}}>
            <div
                style={{display: 'flex', flex: 1, borderRight: `1px dotted ${Colors.border}`}}
                onMouseEnter={() => setState({hover: true})}
                onMouseLeave={() => setState({hover: false})}
            >

                <div style={{flex: 1, padding: 6}}>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <S1 style={{width: 20, marginRight: 12}}>{collo.index + 1}</S1>
                        <P disabled={disabled}>{collo.barcode || 'Geen barcode'}</P>
                    </div>

                    {!!(collo.length || collo.width || collo.height) &&
                        <P disabled={disabled} style={{marginLeft: 36}}>{`${(collo.length / 10).toString().replace('.', ',')} x ${(collo.width / 10).toString().replace('.', ',')} x ${(collo.height / 10).toString().replace('.', ',')} cm`}</P>
                    }

                    {collo.description &&
                        <div style={{display: 'flex'}}>
                            <i style={{width: 20, marginRight: 12, fontSize: 16}} className='mdi mdi-message-outline' />
                            <P disabled={disabled}>{collo.description}</P>
                        </div>
                    }
                </div>

                {(onClickEdit || onClickPrintLabels) && hover ?
                    <div style={{display: 'flex', flexDirection: 'column', width: 150, alignItems: 'flex-end'}}>
                        <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                            {onClickPrintLabels &&
                                <IconButton
                                    onClick={() => onClickPrintLabels(order._id, collo.index)}
                                    icon='mdi mdi-printer'
                                />
                            }

                            {onClickEdit &&
                                <IconButton
                                    icon='mdi mdi-pencil'
                                    onClick={() => onClickEdit(collo.index)}
                                />
                            }
                        </div>

                        {!!collo.weight &&
                            <P disabled={disabled} style={{paddingRight: 6, paddingBottom: 6, visibility: 'hidden', ...(!collo.type && {display: 'none'})}}>{`${formatGrams(collo.weight)} kg`}</P>
                        }
                    </div> :
                    <div style={{display: 'flex', flexDirection: 'column', width: 150, padding: 6, alignItems: 'flex-end'}}>
                        {collo.type &&
                            <P disabled={disabled} style={collo.weight ? {minHeight: 30} : undefined}>{getColliTypeName(collo.type, reseller)}</P>
                        }

                        {!!collo.weight &&
                            <P disabled={disabled}>{`${formatGrams(collo.weight)} kg`}</P>
                        }
                    </div>
                }

            </div>

            <div style={{display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'flex-end'}}>
                <div style={{display: 'flex', alignItems: 'center', padding: 6}}>
                    <div style={{marginRight: 12}}>
                        <P style={{textAlign: 'right'}} disabled={disabled}>{Colors.colloStatusColor('', collo).status}</P>

                        <S2 style={{textAlign: 'right'}} disabled={disabled}>{Colors.colloStatusColor('', collo).reason}{['notcollected', 'notsupplied', 'onhold', 'notdelivered', 'missing', 'refused'].includes(collo.status) && collo.reasonSpecification ? `${collo.reason ? ' - ' : ''}${collo.reasonSpecification}` : ''}</S2>
                    </div>

                    <i style={{fontSize: 12, color: Colors.colloStatusColor('', collo).statusColor}} className='mdi mdi-circle' />
                </div>
            </div>
        </div>

    )
}

ViewOrderCollo.displayName = 'ViewOrderCollo'

export default ViewOrderCollo
